import { api } from 'redux/api/index.api';

function extractItems(data, dataKey) {
  if (Array.isArray(data)) return data;

  const possibleKeys = [
    'items',
    'data',
    'results',
    'members',
    'statuses',
    'priorities',
    'companies',
    'phases',
    dataKey,
  ];
  const foundKey = possibleKeys.find(key => data[key] && Array.isArray(data[key]));

  return foundKey ? data[foundKey] : [];
}

export const genericInfiniteQueryApi = api.injectEndpoints({
  endpoints: builder => ({
    getItems: builder.infiniteQuery({
      query: ({ queryArg, pageParam }) => {
        const { url, method = 'GET', body } = queryArg;
        const { limit, offset } = pageParam;
        const query = {
          url,
          method,
          params: {
            ...queryArg.baseParams,
            limit,
            offset,
          },
        };
        if (method === 'POST') query.body = { ...body };
        return query;
      },
      transformResponse: (response, meta, arg) => extractItems(response, arg.queryArg.dataKey),
      infiniteQueryOptions: {
        initialPageParam: { limit: 25, offset: 0 },
        getNextPageParam: (lastPage, allPages, lastPageParam) => {
          if (lastPage.length < lastPageParam.limit) {
            return undefined;
          }
          return {
            limit: lastPageParam.limit,
            offset: lastPageParam.offset + lastPageParam.limit,
          };
        },
      },
    }),
  }),
  overrideExisting: 'throw',
});

export const { useGetItemsInfiniteQuery } = genericInfiniteQueryApi;
